module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("We were born to unite with our fellow-men and to join in community with the human race.")]), _vm._v(" "), _c('p', {
    staticClass: "right-paraa"
  }, [_c('strong', [_vm._v("CICERO:")]), _vm._v(" "), _c('em', [_vm._v("De finibus,")]), _vm._v(" IV")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Of all animals, men are the least fitted to live in herds. If they were crowded together as sheep are they would all perish in a short time. The breath of man is fatal to his fellows.")]), _vm._v(" "), _c('p', {
    staticClass: "right-paraa"
  }, [_c('strong', [_vm._v("JEAN-JACQUES ROUSSEAU:")]), _vm._v(" "), _c('em', [_vm._v("Emile,")]), _vm._v(" I")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50b50978","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmattera.vue
// module id = 81
// module chunks = 0